/**
 * Copia texto para a área de transferência.
 *
 * `navigator.clipboard` só existe em contexto seguro (HTTPS ou localhost). Em
 * instalações servidas por HTTP puro ele é `undefined` e a cópia simplesmente
 * falha — por isso o fallback com <textarea> + document.execCommand("copy"),
 * que continua funcionando nesses casos.
 *
 * Retorna true/false; quem chama decide a mensagem exibida ao usuário.
 */
export const copyTextToClipboard = async (text) => {
    const value = typeof text === "string" ? text : String(text ?? "");

    if (!value) return false;

    if (window.isSecureContext && navigator?.clipboard?.writeText) {
        try {
            await navigator.clipboard.writeText(value);
            return true;
        } catch (err) {
            // Segue para o fallback: o usuário pode ter negado a permissão.
        }
    }

    const textarea = document.createElement("textarea");
    textarea.value = value;
    textarea.setAttribute("readonly", "");
    textarea.style.position = "fixed";
    textarea.style.top = "0";
    textarea.style.left = "0";
    textarea.style.opacity = "0";
    textarea.style.pointerEvents = "none";

    document.body.appendChild(textarea);

    try {
        textarea.select();
        // setSelectionRange é o que faz a seleção pegar no iOS.
        textarea.setSelectionRange(0, value.length);
        return document.execCommand("copy");
    } catch (err) {
        return false;
    } finally {
        document.body.removeChild(textarea);
    }
};

export default copyTextToClipboard;
